export default __webpack_public_path__ + "static/media/7cc1419f15669897c3c69ace72c4870e.svg";